// #FIXME
// eslint-disable-next-line no-shadow
export enum MessagesEnum {
  WorksheeStructureOutRang = 'worksheet_structure_out_range'
}
